import SubscriptionService from "../../services/subscription-service"
import { makeSubscriptionResource } from "../resources/subscription-resource-factory"

export const makeSubscriptionService = (): SubscriptionService => {
    return new SubscriptionService(makeSubscriptionResource())
}
